import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";
import routes from "../../routes";
import { GlobalStyle } from "./style";
import CentralizeLayout from "../../layouts/centralize";
import DashboardLayout from "../../layouts/dashboard";
import { ToolsDashboardLayout, ToolsFullpageLayout } from "../../layouts/tools";
import FullpageLayout from "../../layouts/fullpage";
import SettingLayout from "../../layouts/setting";
import NoMatch from "../../components/noMatch";
import { InitAction } from "../../actions";
import { getToken } from "../../lib/tokenManager";
import { ConnectedRouter } from "connected-react-router";
import { history } from "../../configureStore";
import { Toast } from "../../components/toast";
import { FullScreenLoading } from "../../components/loading";
import MobileAlert from "./components/mobileAlert";
import DownloadModal from "./components/downloadModal";
import DownloadToast from "./components/downloadToast";
import FeedbackModal from "./components/feedbackModal";
import GuestDeniedModal from "./components/accessDeniedOrReminderModals/guestsDeniedModal";
import { FREE } from "../../constants/premiumState";
import queryString from "query-string";
import PROJECT_STATE from "../../constants/projectState";
import { Confirm } from "../../components/confirm";
import { SERVER_INTERRUPT_MESSAGES } from "../../constants/serverInterrupt";
const ProjectList = React.lazy(() => import("../projectList"));

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accessDeniedModalShow: false
      // loading:false,
    };
    // if (window.location.pathname !== "/purchase") {
    //   sessionStorage.removeItem("user_plan");
    //   sessionStorage.removeItem("calculatePriceData");
    //   sessionStorage.removeItem("lastUrl");
    // }
    const project_state = sessionStorage.getItem("project_state");
    if (
      window.location.pathname !== "/purchase" &&
      project_state &&
      parseInt(project_state) === PROJECT_STATE.INACTIVE
    ) {
      localStorage.removeItem("project_id");
      sessionStorage.removeItem("project_state");
    }
  }
  componentWillMount() {
    if (getToken("refreshToken")) {
      this.props.requestInit();
    }
  }
  async componentDidMount() {
    const searchParam = await queryString.parse(document.location.search);
    if (
      searchParam &&
      Object.keys(searchParam).length === 1 &&
      searchParam.project_id
    ) {
      localStorage.setItem("project_id", searchParam.project_id);
      setTimeout(() => this.props.requestInit());
    }
  }
  layoutManage(item, key) {
    switch (item.layout) {
      case "centralize":
        return (
          <Route
            key={key}
            exact
            path={item.path}
            render={route => (
              <CentralizeLayout
                route={route}
                Component={item.component}
                options={item.options || {}}
              />
            )}
          />
        );
      case "dashboard":
        return (
          <Route
            key={key}
            exact
            path={item.path}
            render={route => (
              <DashboardLayout
                route={route}
                Component={item.component}
                options={item.options || {}}
              />
            )}
          />
        );
      case "tools.dashboard":
        return (
          <Route
            key={key}
            exact
            path={item.path}
            render={route => (
              <ToolsDashboardLayout
                route={route}
                Component={item.component}
                options={item.options || {}}
              />
            )}
          />
        );
      case "tools.fullpage":
        return (
          <Route
            key={key}
            exact
            path={item.path}
            render={route => (
              <ToolsFullpageLayout
                route={route}
                Component={item.component}
                options={item.options || {}}
              />
            )}
          />
        );
      case "fullpage":
        return (
          <Route
            key={key}
            exact
            path={item.path}
            render={route => (
              <FullpageLayout
                route={route}
                Component={item.component}
                options={item.options || {}}
              />
            )}
          />
        );
      case "setting":
        return (
          <Route
            key={key}
            exact
            path={item.path}
            render={route => (
              <SettingLayout
                route={route}
                Component={item.component}
                options={item.options || {}}
                init={this.props.init}
              />
            )}
          />
        );
      default:
        return (
          <Route
            key={key}
            exact
            path={item.path}
            component={item.component}
            options={item.options || {}}
          />
        );
    }
  }
  switchRoutes() {
    const { init } = this.props;
    if (init.project_status) {
      const purchase = routes.filter(
        route => route.visibility === "all" && route.path === "/purchase"
      );
      const invitation = routes.filter(
        route => route.visibility === "all" && route.path === "/invitation"
      );
      if (purchase[0].path === window.location.pathname) {
        return purchase.map((route, key) => this.layoutManage(route, key));
      } else if (invitation[0].path === window.location.pathname) {
        return invitation.map((route, key) => this.layoutManage(route, key));
      } else {
        return (
          <Route
            exact
            path="/*"
            render={route => (
              <CentralizeLayout route={route} Component={ProjectList} />
            )}
          />
        );
      }
    } else {
      return routes.map((route, key) => {
        if (init.data === null && route.visibility !== "trust") {
          return this.layoutManage(route, key);
        } else if (
          init.data !== null &&
          (route.visibility === "trust" || route.visibility === "all")
        ) {
          return this.layoutManage(route, key);
        } else {
          return null;
        }
      });
    }
  }

  mobileAlertShow() {
    if (!getToken("refreshToken")) {
      return <MobileAlert />;
    }
  }
  render() {
    const { init } = this.props;
    if (init.loading && getToken("refreshToken")) {
      return (
        <React.Fragment>
          <GlobalStyle />
          {init.serverInterruptStatus && (
            <Confirm
              show={init.serverInterruptStatus}
              content={{
                type: "danger",
                icon: "icon mapsa-notification",
                message: SERVER_INTERRUPT_MESSAGES[init.serverInterruptStatus],
                acceptButtonText: "بارگذاری مجدد",
                rejectButtonText: "باشه"
              }}
              acceptHandler={() => {
                window.location.reload();
                this.props.changeServerInterruptStatus();
              }}
              rejectHandler={() => {
                this.props.changeServerInterruptStatus();
              }}
            />
          )}
          <FullScreenLoading />
        </React.Fragment>
      );
    } else {
      let authRoutes = [
        "/login",
        "/register",
        "/forget",
        "/verify",
        "/reset-password"
      ];
      if (authRoutes.indexOf(window.location.pathname) < 0) {
        if (
          (!getToken("refreshToken") &&
            window.location.pathname !== "/login") ||
          (getToken("refreshToken") && init.userNotVerified)
        ) {
          window.location.replace("/login");
          return null;
        }
      } else {
        if (
          getToken("refreshToken") &&
          window.location.pathname !== "/verify" &&
          (window.location.pathname !== "/login" || !init.userNotVerified) &&
          window.location.pathname !== "/purchase" &&
          window.location.pathname !== "/invitation" &&
          window.location.pathname !== "/register"
        ) {
          window.location.replace("/");
          return null;
        }
      }

      return (
        <ConnectedRouter history={history}>
          <FeedbackModal />
          <DownloadModal />
          <DownloadToast />
          {this.mobileAlertShow()}
          <GlobalStyle />

          {init.data &&
            init.data.data &&
            !init.data.data.is_owner &&
            init.data.data.project &&
            init.data.data.project.premium_state === FREE && (
              <GuestDeniedModal
                status={true}
                handleShow={show =>
                  this.setState({ accessDeniedModalShow: show })
                }
                shouldReload={true}
                projectId={localStorage.getItem("project_id")}
              />
            )}
          {init.serverInterruptStatus && (
            <Confirm
              show={init.serverInterruptStatus}
              content={{
                type: "danger",
                icon: "icon mapsa-notification",
                message: SERVER_INTERRUPT_MESSAGES[init.serverInterruptStatus],
                acceptButtonText: "بارگذاری مجدد",
                rejectButtonText: "باشه"
              }}
              acceptHandler={() => {
                this.props.changeServerInterruptStatus();
                window.location.reload();
              }}
              rejectHandler={() => {
                this.props.changeServerInterruptStatus();
              }}
            />
          )}

          <Toast />
          <Switch>
            {this.switchRoutes()}
            <Route component={NoMatch} />;
          </Switch>
        </ConnectedRouter>
      );
    }
  }
}
const mapStateToProps = store => {
  return {
    init: store.Init
  };
};
const mapDispatchToProps = dispatch => {
  return {
    requestInit: () => {
      dispatch(InitAction.get());
    },
    changeServerInterruptStatus: status => {
      dispatch(InitAction.changeServerInterruptStatus(status));
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);
